import "./DisplayPropertyTypes.css";
import React, { useEffect, useState } from "react";
import Table from "../../../components/common/table/Table";
import { openModal } from "../../../redux/modal/modalActions";
import { useDispatch } from "react-redux";
import { getAllPropertyTypes } from "../../../apis/propertiesApis/getAllPropertyTypes";
import ResponseModal from "../../../components/common/modal/responseModal/ResponseModal";

function DisplayPropertyTypes() {
  const dispatch = useDispatch();
  const [PropertyTypesData, setPropertyTypesData] = useState([]);

  useEffect(() => {
    const getPropertyTypes = async () => {
      try {
        const allPropertyTypesRes = await getAllPropertyTypes();
        if (
          allPropertyTypesRes.error_code === 2 ||
          allPropertyTypesRes.error_code === 3
        ) {
          dispatch(
            openModal(
              <ResponseModal
                text={allPropertyTypesRes.error_message}
                isError={true}
              />
            )
          );
        } else {
          setPropertyTypesData(allPropertyTypesRes.res.data);
        }
      } catch (error) {
        console.error("Error fetching Project Types:", error);
      }
    };
    getPropertyTypes();
  }, [dispatch]);

  const tableHeaders = [
    {
      key: "id",
      name: "ID",
    },
    {
      key: "name",
      name: "Name",
    },
  ];

  return (
    <>
      <strong className="strong-margin">Project Types List : </strong>
      <div className="table-main-container-displayPropertyTypes">
        <Table
          tableHeight={"350px"}
          headers={tableHeaders}
          rows={PropertyTypesData}
        />
      </div>
    </>
  );
}

export default DisplayPropertyTypes;
